import { type ReactNode } from 'react'
import { cm } from '~/utils'

const RIGHT_PANEL_MARKDOWN_CLASS = 'landing-right-panel-markdown'

const rightPanelHorizontalScrollCss = `
.${RIGHT_PANEL_MARKDOWN_CLASS} {
  min-width: 100%;
  max-width: none;
}

.${RIGHT_PANEL_MARKDOWN_CLASS} table {
  width: max-content;
  min-width: 100%;
  max-width: none;
  table-layout: auto;
}

.${RIGHT_PANEL_MARKDOWN_CLASS} th,
.${RIGHT_PANEL_MARKDOWN_CLASS} td {
  white-space: nowrap;
  word-break: normal;
  overflow-wrap: normal;
}

.${RIGHT_PANEL_MARKDOWN_CLASS} .codeblock {
  width: max-content;
  min-width: 100%;
  max-width: none;
}

.${RIGHT_PANEL_MARKDOWN_CLASS} .codeblock pre,
.${RIGHT_PANEL_MARKDOWN_CLASS} .codeblock code {
  width: max-content !important;
  max-width: none !important;
  white-space: pre !important;
  word-break: normal !important;
  overflow-wrap: normal !important;
}

.${RIGHT_PANEL_MARKDOWN_CLASS} code {
  word-break: normal !important;
  overflow-wrap: normal !important;
}
`

interface RightPanelHorizontalScrollProps {
  children: ReactNode
  className?: string
  contentClassName?: string
  testId?: string
}

export function RightPanelHorizontalScroll({
  children,
  className,
  contentClassName,
  testId
}: RightPanelHorizontalScrollProps) {
  return (
    <div data-testid={testId} className={cm('h-full min-h-0 min-w-0 overflow-auto', className)}>
      <style dangerouslySetInnerHTML={{ __html: rightPanelHorizontalScrollCss }} />
      <div className={cm('min-w-full', contentClassName)}>{children}</div>
    </div>
  )
}

export function RightPanelHorizontalScrollStyles() {
  return <style dangerouslySetInnerHTML={{ __html: rightPanelHorizontalScrollCss }} />
}

export { RIGHT_PANEL_MARKDOWN_CLASS }
